module.exports = __webpack_public_path__ + "static/img/ico-left-arrow.158f505.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/ico-left-arrow.png
// module id = SRpa
// module chunks = 1